<template>
  <v-container fluid pa-0 ma-0 fill-height style="background-color: white;">
    <v-layout column wrap fill-height justify-center align-center class="ma-0 pa-0">

      <v-flex class="mx-auto" style="flex-grow: 0;">
        <p class="text-xs-left mx-auto mb-5" style="width: fit-content; font-size: 30px; font-weight: 300; letter-spacing: -0.5px; line-height: 36px;">
          <span style="font-weight: 700;">로그인</span>이<br>
          필요한 서비스에요!
        </p>

        <img src="@/assets/img/yuni-sit.png" class="mb-4" style="width: 113px;">

        <div class="mx-auto">
          <v-btn v-for="(button, index) of buttons" :key="index"
                 :loading="button.loading"
                 :disabled="loading"
                 block :color="button.backgroundColor"
                 class="px-3 mb-4 button-style"
                 @click="signAs(button)">
            <v-layout align-center class="px-4">
              <img :src="button.src" style="width: 22px; height: 22px; margin-right: 34px;">
              <span :style="{ color: button.type === 'facebook' || button.type === 'apple' ? 'white' : '' }">{{ button.name }}으로 시작하기</span>
            </v-layout>
          </v-btn>

          <v-layout class="pt-2 mx-auto" style="width: fit-content;">
<!--            <v-btn small flat class="mr-0 my-0 pa-0" :ripple="false">이미 회원이신가요?</v-btn>-->
            <v-btn small flat class="ma-0" style="font-weight: 700;" @click="$router.push({ name: 'EmailLogin', query: $route.query })">이메일로 로그인/회원가입하기</v-btn>
  <!--            <v-divider vertical style="height: 12px; margin-top: 10px;"></v-divider>-->
  <!--            <v-btn small flat class="mr-0 my-0" @click="$router.push({ name: 'EmailSignUp', query: $route.query })">이메일로 가입</v-btn>-->
          </v-layout>
        </div>

      </v-flex>

    </v-layout>

    <v-snackbar v-model="snackbar" bottom vertical :timeout="3000" auto-height>
      {{ errorMessage }}
      <v-btn color="primary" flat @click="snackbar = false">닫기</v-btn>
    </v-snackbar>

  </v-container>
</template>

<script>
  import firebase from 'firebase/app';
  import 'firebase/auth';
  import { mapActions } from 'vuex';

  export default {
    name: 'SocialLogin',
    data () {
      return {
        loading: false,
        buttons: [
          {
            type: 'kakao',
            src: require('@/assets/img/kakaotalk.png'),
            name: '카카오톡',
            loading: false,
            backgroundColor: '#ffed00',
          },
          {
            type: 'facebook',
            src: require('@/assets/img/facebook.png'),
            name: '페이스북',
            loading: false,
            backgroundColor: '#1877f2',
          },
          {
            type: 'google',
            src: require('@/assets/img/google.png'),
            name: '구글',
            loading: false,
            backgroundColor: '#f4f4f4',
          },
          {
            type: 'apple',
            src: require('@/assets/img/apple.png'),
            name: '애플',
            loading: false,
            backgroundColor: '#000000',
          }
        ],
        errorMessage: '',
        snackbar: false,
      };
    },
    created () {
      // 네이티브 소셜 로그인 인터페이스: signSuccess, signCancel in main.js
      this.$eventBus.$on('signSuccess', this.nativeSignSuccess);
      this.$eventBus.$on('signCancel', this.nativeSignCancel);
    },
    mounted () {
      const root = this;
      root.loading = true;
      // firebase auth redirect catch
      // TODO: Uncaught Error: only one instance of babel-polyfill is allowed (?)
      firebase.auth().getRedirectResult().then(function (result) {
        console.log(result);
        if (result.user) {
          const type = result.user.providerData[0].providerId.split('.')[0]; // 'google' or 'facebook' or 'apple'
          const button = root.buttons.filter(el => el.type === type)[0];
          button.loading = true;
          result.user.getIdToken().then(idToken => {
            root.signUser({
              social_type: type,
              token: idToken,
              name: result.user.displayName,
              email: result.user.email,
              profile_image: result.user.photoURL,
            }).then(response => {
              console.log(response);
              root.loading = false;
              root.setJWT(response.data.token);
              root.setUser(response.data);
              root.$router.replace(root.$route.query.redirect ? root.$route.query.redirect : { name: 'Home' });
            }).catch(err => {
              console.error(err);
              root.showErrorSnackbar('오류가 발생했습니다. 잠시 후 다시 시도해보세요.');
            });
          }).catch(err => {
            console.error(err);
            root.showErrorSnackbar('계정 연동 과정에서 오류가 발생했습니다. 잠시 후 다시 시도해보세요.');
          });
        } else {
          root.loading = false;
        }
      }).catch(err => {
        console.error(err);
        root.showErrorSnackbar('계정 연동 과정에서 오류가 발생했습니다. 잠시 후 다시 시도해보세요.');
      });
    },
    methods: {
      ...mapActions('user', [ 'signUser', 'setUser', 'setJWT' ]),
      signAs (button) {
        const root = this;
        const type = button.type;
        root.loading = true;
        button.loading = true;
        // 네이티브에서 로그인
        if (typeof webkit !== 'undefined') { // iOS
          // eslint-disable-next-line no-undef
          webkit.messageHandlers.signIn.postMessage(type);
        } else if (window.native) { // android
          window.native.signIn(type);
        // 브라우저에서 로그인
        } else {
          if (type === 'kakao') {
            // 만약 로컬스토리지에 카카오 토큰이 존재하면 (로그아웃이 제대로 안 되었거나 하는 경우) 삭제해서 새로 발급받도록 함
            const kakaoTokenKey = Object.keys(window.localStorage).filter(el => el.includes('kakao'));
            if (kakaoTokenKey.length) window.localStorage.removeItem(kakaoTokenKey[0]);
            // eslint-disable-next-line
            Kakao.Auth.login({
              // throughTalk: false,
              success: function (authObj) {
                console.log(authObj);
                window.Kakao.API.request({
                  url: '/v2/user/me',
                  success: function (response) {
                    console.log(response);
                    root.signUser({
                      token: authObj.access_token,
                      social_type: 'kakao',
                      name: response.properties.nickname,
                      email: response.kakao_account.has_email ? response.kakao_account.email : null,
                      profile_image: response.properties.profile_image ? response.properties.profile_image : null,
                    }).then(response => {
                      console.log(response);
                      root.loading = false;
                      root.setJWT(response.data.token);
                      root.setUser(response.data);
                      root.$router.replace(root.$route.query.redirect ? root.$route.query.redirect : { name: 'Home' });
                    }).catch(err => {
                      console.error(err);
                      root.showErrorSnackbar('오류가 발생했습니다. 잠시 후 다시 로그인해주세요.');
                    });
                  },
                  fail: function (err) {
                    console.error(err);
                    root.showErrorSnackbar('카카오 로그인 과정에서 오류가 발생했습니다. 잠시 후 다시 시도해보세요.');
                  }
                });
              },
              fail: function (err) {
                console.error(err);
                root.showErrorSnackbar('카카오 로그인 과정에서 오류가 발생했습니다. 잠시 후 다시 시도해보세요.');
              }
            });
          } else if (type === 'google') {
            let provider = new firebase.auth.GoogleAuthProvider();
            firebase.auth().signInWithRedirect(provider);
          } else if (type === 'facebook') {
            let provider = new firebase.auth.FacebookAuthProvider();
            firebase.auth().signInWithRedirect(provider);
          } else if (type === 'apple') {
            let provider = new firebase.auth.OAuthProvider('apple.com');
            firebase.auth().signInWithRedirect(provider);
          }
        }
      },
      showErrorSnackbar (message) {
        this.loading = false;
        this.errorMessage = message;
        this.snackbar = true;
      },
      nativeSignSuccess (user) {
        this.loading = true;
        const newUser = JSON.parse(user);
        this.signUser(newUser).then(response => {
          this.setJWT(response.data.token);
          this.setUser(response.data);
          this.$router.replace(this.$route.query.redirect ? this.$route.query.redirect : { name: 'Home' });
        }).catch(err => {
          console.error(err);
          this.showErrorSnackbar('계정 연동 과정에서 오류가 발생했습니다. 잠시 후 다시 시도해보세요.');
        });
      },
      nativeSignCancel () {
        this.loading = false;
      },
    },
  }
</script>

<style lang="scss" scoped>
  .button-style {
    border: 0;
    border-radius: 28px;
    box-shadow: none !important;
    width: 280px;
    height: 56px;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: -0.2px;
  }
  /deep/.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
    background-color: white !important;
  }
</style>
